'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var React = require('react');
var utils = require('@chakra-ui/utils');
var BadgeIcon = require('./BadgeIcon.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["className", "children", "leftIcon", "rightIcon", "iconSpacing"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * Badge
 *
 * React component used to display notifications, messages, or statuses in different shapes and sizes.
 *
 * @see Docs https://chakra-ui.com/badge
 */
var Badge = react.forwardRef(function (props, ref) {
  var styles = react.useStyleConfig('Badge', props);
  var _omitThemingProps = react.omitThemingProps(props);
  _omitThemingProps.className;
  var children = _omitThemingProps.children,
    leftIcon = _omitThemingProps.leftIcon,
    rightIcon = _omitThemingProps.rightIcon,
    _omitThemingProps$ico = _omitThemingProps.iconSpacing,
    iconSpacing = _omitThemingProps$ico === void 0 ? '0.15rem' : _omitThemingProps$ico,
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.span, _extends__default["default"]({
    ref: ref,
    className: utils.cx('chakra-badge', props.className)
  }, rest, {
    __css: _objectSpread({
      display: 'inline-flex',
      whiteSpace: 'nowrap',
      verticalAlign: 'middle'
    }, styles)
  }), leftIcon && /*#__PURE__*/React__default["default"].createElement(BadgeIcon.BadgeIcon, {
    marginEnd: iconSpacing
  }, leftIcon), children, rightIcon && /*#__PURE__*/React__default["default"].createElement(BadgeIcon.BadgeIcon, {
    marginStart: iconSpacing
  }, rightIcon));
});
Badge.displayName = 'Badge';
exports.Badge = Badge;